import { GetBillingScheduleList, InsertBillingSchedule, UpdateBillingSchedule } from "../../../services/requests/billing/misc-billing-requests";
import { DataSource } from "../../UI/view/data-source";

export const miscBillingScheduleDS = {
  request: GetBillingScheduleList,
  pk: 'id',
  name: 'miscBillingSchedule',
  updateRequest: UpdateBillingSchedule,
  createRequest: InsertBillingSchedule,
} as DataSource;